export const Dashboard = () => {
  return (
    <div className="App h-screen login-container-gradient pl-80">Dashboard</div>
  );
};
